import { render, staticRenderFns } from "./PdpaMktNextMoney.vue?vue&type=template&id=10e7592d&scoped=true&"
import script from "./PdpaMktNextMoney.vue?vue&type=script&lang=js&"
export * from "./PdpaMktNextMoney.vue?vue&type=script&lang=js&"
import style0 from "./PdpaMktNextMoney.vue?vue&type=style&index=0&id=10e7592d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e7592d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
